import React, { useState } from 'react';
import ABDMQRScanner from './ABDMQRScanner';
import ABDMConsentManager from './ABDMConsentManager';
import ABDMPHRViewer from './ABDMPHRViewer';

export default function ABDMIndex() {
  const [activeTab, setActiveTab] = useState('overview');

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white p-6">
        <div className="max-w-6xl mx-auto">
          <h1 className="text-4xl font-bold mb-2">🏥 ABDM Integration Suite</h1>
          <p className="text-blue-100">UpchaarQ का complete ABDM implementation</p>
        </div>
      </div>

      <div className="bg-white border-b sticky top-0 z-40">
        <div className="max-w-6xl mx-auto px-6 py-4">
          <nav className="flex gap-4 flex-wrap">
            <button
              onClick={() => setActiveTab('overview')}
              className={`px-4 py-2 rounded-lg font-medium transition ${
                activeTab === 'overview'
                  ? 'bg-blue-600 text-white'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              📋 Overview
            </button>
            <button
              onClick={() => setActiveTab('qr')}
              className={`px-4 py-2 rounded-lg font-medium transition ${
                activeTab === 'qr'
                  ? 'bg-blue-600 text-white'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              📱 QR Scanner
            </button>
            <button
              onClick={() => setActiveTab('consent')}
              className={`px-4 py-2 rounded-lg font-medium transition ${
                activeTab === 'consent'
                  ? 'bg-blue-600 text-white'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              🔐 Consent
            </button>
            <button
              onClick={() => setActiveTab('phr')}
              className={`px-4 py-2 rounded-lg font-medium transition ${
                activeTab === 'phr'
                  ? 'bg-blue-600 text-white'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              📁 PHR Viewer
            </button>
          </nav>
        </div>
      </div>

      <div className="py-6">
        <div className={activeTab === 'overview' ? 'block' : 'hidden'}><OverviewTab /></div>
        <div className={activeTab === 'qr' ? 'block' : 'hidden'}><ABDMQRScanner /></div>
        <div className={activeTab === 'consent' ? 'block' : 'hidden'}><ABDMConsentManager /></div>
        <div className={activeTab === 'phr' ? 'block' : 'hidden'}><ABDMPHRViewer /></div>
      </div>
    </div>
  );
}

function OverviewTab() {
  return (
    <div className="max-w-6xl mx-auto px-4 py-6">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        <div className="bg-white rounded-lg shadow-lg p-6 border-l-4 border-blue-500">
          <div className="text-4xl mb-3">📱</div>
          <h3 className="text-xl font-bold mb-2">QR Scanner</h3>
          <p className="text-gray-600 text-sm">Hospital और patient QR codes generate करो।</p>
        </div>

        <div className="bg-white rounded-lg shadow-lg p-6 border-l-4 border-green-500">
          <div className="text-4xl mb-3">🔐</div>
          <h3 className="text-xl font-bold mb-2">Consent Manager</h3>
          <p className="text-gray-600 text-sm">Patient की health records access के लिए consent लो।</p>
        </div>

        <div className="bg-white rounded-lg shadow-lg p-6 border-l-4 border-purple-500">
          <div className="text-4xl mb-3">📁</div>
          <h3 className="text-xl font-bold mb-2">PHR Viewer</h3>
          <p className="text-gray-600 text-sm">Doctor का personal health records viewer।</p>
        </div>
      </div>


    </div>
  );
}
